import React from 'react'
import {
  DepartmentNavigationListSubSectionFragment,
  DepartmentNavigationLabelStyle
} from '#src/generated/graphql'
import DepartmentNavigationLink from '../../common/DepartmentNavigationLink'
import styles from './styles.css'
import { Image } from '@deal/components'

interface DesktopNavigationListSubSectionProps {
  section: DepartmentNavigationListSubSectionFragment
  onLinkClick?: React.MouseEventHandler
}

const DesktopNavigationListSubSection: React.SFC<DesktopNavigationListSubSectionProps> = ({
  section,
  onLinkClick
}) => {
  return (
    <ul className={styles.list}>
      {section.items.map(item => {
        return (
          <li key={item.id} className={styles.listItem}>
            <DepartmentNavigationLink
              link={item.link}
              onClick={onLinkClick}
              className={styles.listItemLink}
              activeClassName={styles.listItemLinkActive}
            >
              {item.imageUrl && (
                <Image
                  src={item.imageUrl}
                  height={40}
                  width={40}
                  className={styles.listItemImage}
                />
              )}
              {item.labelStyles.find(style => style === DepartmentNavigationLabelStyle.BOLD) ? (
                <strong>{item.label}</strong>
              ) : (
                <span>{item.label}</span>
              )}
            </DepartmentNavigationLink>
          </li>
        )
      })}
    </ul>
  )
}

export default DesktopNavigationListSubSection
